import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './Auth.service';
import { LocalStorageService } from '../../../shared/services/LocalStorage.service';

@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {
  
  // estas se bloquean si se les ponen headers (mapbox no, pero por si a caso)
  private excludedUrls: string[] = [
    'maps.googleapis.com',
    'api.mapbox.com'
  ];

  constructor(private router: Router, private toastService: ToastrService, private authService: AuthService, private localStorageService: LocalStorageService) {}
  
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> 
  {
    
    const isExternalUrl = this.excludedUrls.some(url => request.url.includes(url));
    if (isExternalUrl) {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        })
      );
    }

    const access_token  = this.localStorageService.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${access_token}`,
      "X-Requested-With": "XMLHttpRequest",
    });

    request = request.clone({
      headers
    });
  
  
   return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = "";
        switch (error.status) {
          case 400:
            {
              this.toastService.error(
              "El servidor no ha contestado correctamente",
              "400 BadRequest"
              );
              break;
            }
            
          }
            return throwError(errorMessage);
      })
   )}
}
